import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/lib/useOnlineStatus";

export const OfflineBanner = () => {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div
      data-testid="offline-banner"
      role="status"
      className="fixed inset-x-0 top-0 z-[200] flex items-center justify-center gap-2 bg-[var(--tc-text)] px-4 py-2.5 text-center text-sm font-medium text-white tc-fade-up"
    >
      <WifiOff size={16} className="shrink-0" />
      Sin conexión — los datos no se van a actualizar hasta que vuelva la señal
    </div>
  );
};
